import React from "react";
import { View, StyleSheet } from "react-native";
import ThreadCard from "../ThreadCard/ThreadCard";

interface Author {
  id: string;
  name: string;
}

interface Commenter {
  id: string;
  name: string;
}

interface LatestComment {
  author: Commenter;
  timestamp: string;
}

interface Post {
  id: string;
  created: string;
  depth: number;
}

interface Thread {
  id: string;
  title: string;
  message: string;
  author: Author;
  responseCount: number;
  commenters: Commenter[];
  latestComment: LatestComment;
  posts?: Post[];
}

interface ThreadCardListProps {
  threads: Thread[];
  onThreadPress: (threadId: string) => void;
}

const ThreadCardList: React.FC<ThreadCardListProps> = ({ threads, onThreadPress }) => {
  return (
    <View style={styles.container}>
      {threads.map((thread) => (
        <ThreadCard
          key={thread.id}
          id={thread.id}
          title={thread.title}
          message={thread.message}
          author={thread.author}
          responseCount={thread.responseCount}
          commenters={thread.commenters}
          latestComment={thread.latestComment}
          posts={thread.posts}
          onPress={onThreadPress}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    borderRadius: 12,
  },
});

export default ThreadCardList;
